import { useState, useEffect } from "react";
import React from "react";
import {
  machineProfile,
  part,
  workOrder,
  vendor,
  customer,
  team,
  user,
  asset,
  workOrderCategory,
  meter,
 
  issueTrackingType,
  issueTracking,
} from "../../api";
import { toast } from "react-toastify";
import {
  dateFormat,
  generateLocationToArray,
  getEmptyField,
  printLocation,
  renderImage,
} from "../../utils/helper";
import { QRCode } from "react-qrcode-logo";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useDashboardContext } from "../../contexts/NewDashboardContext";
import LoadingIndicator from "../../components/LoadingIndicator";
import NormalInput from "../../components/form/HorizontalNormalInput";
import NormalSelect from "../../components/form/HorizontalNormalSelect";
import NormalTextArea from "../../components/form/HorizontalNormalTextarea";
import MultipleFilesAttachments from "../../components/MultipleFilesAttachments";
import "react-datetime/css/react-datetime.css";
import { Card, CardBody, CardHeader } from "../../components/card/card";

import ImageViewer from "../../components/ImageViewer";
import { format, isBefore } from "date-fns";
import { Task } from "../../components/Task";
import Swal from "sweetalert2";
import { InventorySelector } from "../../components/InventorySelector";
import TimeTracking from "../../components/TimeTracking";
import AdditionalCost from "../../components/AdditionalCost";
import { LocationFilter } from "../../components/LocationFilter";

function setupLocationValues(locationSeq, location) {
  locationSeq.push(location.id);
  if (location.parent_location) {
    setupLocationValues(locationSeq, location.parent_location);
  }
}


const defaultIssueTypes = [
  // Length
  "Maintenance",
  "Trouble Shooting",
  "Repair",
  "Inspection",
  "Installation",
  "Other",  
];



function AddIssueTracking() {
  const { id } = useParams();
  const [searchParams, setSearchParams] = useSearchParams();
  const meter_id = searchParams.get("meter_id");
  const editMode = !!id;

  const { locations, addSetupDone } = useDashboardContext();

  const [locationValue, setLocationValue] = useState([]);
  const [vendorList, setVendor] = useState([]);
  const [customerList, setCustomer] = useState([]);
  const [types, setTypes] = useState([]);
  const [newType, setNewType] = useState("");
  const [schedules, setSchedules] = useState([]);
  const [assets, setAssets] = useState([]);
  const [sublocations, setSublocations] = useState([]);
  const { getLocationName, username } = useAuth();
  const [teams, setTeams] = useState([]);
  const [users, setUsers] = useState([]);
  const [assetComponents, setAssetComponents] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dataToSend, setDataToSend] = useState({
    asset_id: "",
    type_id: "",
    location_id: "",
    description: "",
    title: "",
  });
  const navigate = useNavigate();
  function backToList() {
    navigate(-1);
  }

  const [preview, setPreview] = useState();
  const [attachments, setAttachments] = useState([]);
  const [selectedFile, setSelectedFile] = useState("");
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [selectedLocationPrev, setSelectedLocationPrev] = useState([]);

  const [emptyField, setEmptyField] = useState([]);

  async function getMasterData() {
    setIsLoading(true);
    try {
     


      const getType = issueTrackingType.list({});

      const [ resType] = await Promise.all([
       
        getType,
      ]);

   
   
    
    
      if (resType.ok) {
        const body = await resType.json();
        let data = body.data;
        if (data) {

          const filteredDefaultTypes = defaultIssueTypes.filter(unit => !data.some(d => d.name.toLowerCase() === unit.toLowerCase())).map(unit => ({name:unit,id:unit}));     
          const allTypes = [...data, ...filteredDefaultTypes];
          allTypes.map((d) => {
            d["name"] = d.name;
            d["value"] = d.id;
          });
          setTypes(allTypes);
        }
      }

      if (editMode) {
        await getRecord();
      }

      setSublocations([locations]);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    if (locations.length) getMasterData();
  }, [locations]);

  useEffect(() => {
    if (!selectedFile) {
      setPreview(undefined);
      return;
    }
    //console.log({ selectedFile });
    const objectUrl = URL.createObjectURL(selectedFile);
    const newAttachment = {
      name: selectedFile.name,
      value: objectUrl,
    };
    setAttachments((prev) => [...prev, newAttachment]);
    // setPreview(objectUrl);
    //console.log({ objectUrl });
    // free memory when ever this component is unmounted
    return () => URL.revokeObjectURL(objectUrl);
  }, [selectedFile]);

  async function getRecord() {
    const result = await issueTracking.getOne(id);

    if (result.ok) {
      const body = await result.json();
      let data = body.data;

      const defaultValue = {
        asset_id: data.asset_id,
        description: data.description,
        title: data.title,
        type_id: data.type_id,
        location_id: data.location_id,
      };
      

      if (data.asset?.location) {
        //find parent
        const locationSeq = [];
        setupLocationValues(locationSeq, data.asset.location);
        locationSeq.reverse();
        setSelectedLocation(data.asset.location);
        setSelectedLocationPrev(locationSeq);
      } else if (data.location) {
        const locationSeq = [];
        setupLocationValues(locationSeq, data.location);
        locationSeq.reverse();
        setSelectedLocation(data.location);
        setSelectedLocationPrev(locationSeq);
      }

      //loop data.attachments object and insert into attachments array
      const att = [];
      if (data.attachments) {
        Object.keys(data.attachments).forEach((key) => {
          if (data.attachments[key]) {
            const name = key.split("_")[3];
            const type = key.split("_")[2];
            const url = renderImage(
              `machine/attachment/${data.attachments[key]}`
            );
            const attachment = {
              origin_key: key,
              name: name,
              exist: true,
              type,
              url,
              value: data.attachments[key],
            };
            att.push(attachment);
          }
        });
        setAttachments(att);
      }

      setDataToSend(defaultValue);
    }
  }

  const handleAddNewType = async () => {
    if (!newType) return;
    const result = await issueTrackingType.create({
      name: newType,
    });

    if (result.ok) {
      const body = await result.json();
      const data = body.data;
      setTypes((prev) => [{ ...data }, ...prev]);
      setNewType("");
    }
  };

  const handleOnchange = (e) => {

    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  };
  const handleOnchangeAsset = (e) => {
    let key = e.target.name;

    setDataToSend((prevData) => ({
      ...prevData,
      [key]: e.target.value,
    }));
  
  };

  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      let payload = { ...dataToSend };

      payload["location_id"] = selectedLocation?.id;
        
      const mandatory = [
        "title",
        "description",
        "type_id",
        "location_id",
      ];

      const ef = getEmptyField(payload, mandatory);

     
      setEmptyField(ef);
      if (ef.length > 0) {
        toast.error("Mandatory field must be filled");
        return;
      }

      //console.log({ payload });
      let res;
      if (!editMode) {
        res = await issueTracking.create(payload, attachments);
    
      } else {
        res = await issueTracking.update(id, payload, attachments);
       
      }

      if (res.ok) {
       
          toast.success(
            `Your issue has been ${editMode ? "updated" : "created"}`
          );
        

        if (!editMode) {
          backToList();
        }
      } else {
        const errorBody = await res.json();
        toast.error(
          errorBody.message || "Something went wrong, please try again"
        );
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    let sublocations = locations;
    const copy = [sublocations];

    const findSublocation = (lv, index) => {
      const location = sublocations.find((l) => l.id == lv);

      if (
        location &&
        location.sublocations &&
        location.sublocations.length > 0
      ) {
        copy.splice(index + 1);
        copy.push(location.sublocations);
        sublocations = location.sublocations;
      } else {
        copy.splice(index + 1);
      }
    };

    if (locationValue.length > 0) {
      locationValue.forEach((lv, index) => {
        findSublocation(lv, index);
      });
      setSublocations(copy);
    }
  }, [locationValue]);

  //new location implementation
  const handleChangeLocation = (location, selectedLocationPrev) => {
    setSelectedLocation(location);
    setSelectedLocationPrev(selectedLocationPrev);
    handleOnchangeAsset({
      target: {
        name: "asset_id",
        value: "",
      },
    });
    
  };

  useEffect(() => {
    if (selectedLocation) {
      getAsset(selectedLocation.id);
    } else {
      setAssets([]);
    }
  }, [selectedLocation]);


  const getAsset = async (location_id) => {
    const res = await asset.list({ location_id });
    if (res.ok) {
      const body = await res.json();
      let data = body.data;
      if (data) {
        data.map((d) => {
          d["component"] = d.asset_components;
          d["name"] = d.asset_name;
          d["value"] = d.id;
        });
        setAssets(data);
      }
    }
  };

  useEffect(() => {
    if (locationValue.length > 0) {
      const location_id = locationValue[locationValue.length - 1];
      getAsset(location_id);
    }
  }, [locationValue]);

  return (
    <Card>
      <LoadingIndicator open={isLoading} />
      <CardHeader>
        {editMode && "Edit "}
        Issue Tracking Information
      </CardHeader>

      <CardBody>
        <div className="row g-3">
          <div className="col-md-6">
            <NormalInput
              label={`Title`}
              value={dataToSend["title"]}
              onchange={handleOnchange}
              name={"title"}
              type="text"
              id="workOrderTitle"
              emptyField={emptyField}
              className="form-control"
              required
            />

            
<NormalTextArea
              label={"Description"}
              onchange={handleOnchange}
              value={dataToSend["description"]}
              name={"description"}
              type="text"
              id="description"
              className="form-control"
              emptyField={emptyField}
              required
            />


<NormalSelect
                required={true}
                value={dataToSend["type_id"]}
                label="Issue Type"
                onchange={handleOnchange}
                list={types}
                name="type_id"
                emptyField={emptyField}
              valueKey={"id"}
              onSubmit={handleAddNewType}
              addMoreComponent={
                <NormalInput
                required={true}
                value={newType}
                label="Issue Type"
                onchange={(e)=>{setNewType(e.target.value)}}
              />
              }
                />
          


            <LocationFilter
              type="input"
              onChange={handleChangeLocation}
              defaultValue={selectedLocation}
              defaultOptionsValue={selectedLocationPrev}
              emptyField={emptyField}
            />

            <NormalSelect
              label={"Asset"}
              onchange={handleOnchangeAsset}
              value={dataToSend["asset_id"]}
              name={"asset_id"}
              id="asset"
              className="form-select"
              list={assets}
              valueKey={"id"}
              emptyField={emptyField}
            />


<Card style={{ marginTop: "10px" }}>
          <CardHeader>Attachments</CardHeader>
          <CardBody>
            <MultipleFilesAttachments
              attachments={attachments}
              setAttachments={setAttachments}
            ></MultipleFilesAttachments>
          </CardBody>
        </Card>


          </div>

         
        
         
          

         
          
        </div>
       


       
          <div className="mt-4 flex">
            <button
              className="btn btn-outline-theme btn-lg me-2"
              onClick={handleSubmit}
            >
              {editMode ? "SAVE" : "ADD"}
            </button>
            <button
              className="btn btn-outline-danger btn-lg"
              onClick={backToList}
            >
              CANCEL
            </button>
          </div>

        
      </CardBody>
    </Card>
  );
}

export default AddIssueTracking;
